import React, {useEffect, useState} from "react";
import { AnimatePresence, motion } from "framer-motion";
import { getGutterWidth } from "../../globals/helpers";
import { projData } from "../../globals/data";
import { sideVertVariants, upperHorizVariants } from "./variants";
import { primaryInput } from "detect-it";
import { gridTileScales, imageSizingMapping } from "../../globals/variables";


const HomepageOverlayTransition = ({triggerHomepageToProjectTransition}) => {

    const [projectScaler, setProjectScaler] = useState([0,0]);
    const [expandTransHeight, setExpandTransHeight] = useState(Math.min((window.innerWidth - (getGutterWidth(window.innerWidth).main *2)) * (9/16), window.innerHeight - 180));
    const [expandLowerHeight, setExpandLowerHeight] = useState(Math.min((window.innerWidth - (getGutterWidth(window.innerWidth).main *2)) * (9/16), window.innerHeight - 180));
    const [sideTransGutter, setSideTransGutter] = useState(getGutterWidth(window.innerWidth).main);
    const [startTileWidth, setStartTileWidth] = useState(null);
    const [startTileHeight, setStartTileHeight] = useState(null);
    const [isTablet, setIsTablet] = useState(null);
    const [tileScales, setTileScales] = useState(null);
    const [dynamicSrcType, setDynamicSrcType] = useState(null);
    const [useData, setUseData] = useState(null);


    const projTransVariants = {
        initial: {
            opacity: 0,
            transform: "translate(-50%, calc(50vh - 60px - 50%))",
        }, animate: (i)  => ({
            opacity: 1,
            transform: `translate(-50%, 0) scale(${projectScaler[0]}, ${projectScaler[1]})`,
            transition: {
                duration: i[1] ? 1.25 :1,
                delay: i[1] ? 1.5 : 1.5,
                ease: i[1] ? [0.87, 0, 0.13, 1] : [0.16, 1, 0.3, 1],
                opacity: {
                    delay: i[1] ? 1 : 0.5,
                    duration: 0.25,
                    ease: [0.87, 0, 0.13, 1]
                }
            }
        }), exit:{
            
        }
    }

    const transCounterVariants = {
        initial: (i) => ({
            opacity: i[2] ? 0 : 1,
            transform: `scale(${i[0]}, ${i[0]})`
        }), animate: (i)  => ({
            opacity: 1,
            transform: `scale(1, ${projectScaler[0]/projectScaler[1]})`,
            transition: {
                duration: i[1] ? 1.25 : 1,
                delay: i[1] ? 1.5 : 1.5,
                ease: i[1] ? [0.87, 0, 0.13, 1] : [0.16, 1, 0.3, 1],
                opacity: {
                    duration: i[2] ? 2 : null, 
                    ease: "easeInOut",
                }
            }
        }), exit: (i) => ({
            opacity: 0,
            transform: `scale(1, ${projectScaler[0]/projectScaler[1]})`,
            transition: {
                duration: 3
            }
        })
    }

    const resizeListener = () => {
        try{
            let curWidth = window.innerWidth;
            let replaceSrcWith;
            Object.entries(imageSizingMapping).forEach(([key, value]) => {
                if(curWidth>= value[0] && curWidth <= value[1]){
                    replaceSrcWith = key;
                }
            });
            setDynamicSrcType(replaceSrcWith);
        }catch{

        }
    }



    useEffect(() => {
        if(primaryInput !== "mouse") setIsTablet(true); else setIsTablet(false);


        resizeListener()
        window.addEventListener("resize", resizeListener, false);
        return () => {
            window.removeEventListener("resize", resizeListener, false);
        };
    }, [])

    useEffect(() => {
        if(triggerHomepageToProjectTransition){
            setUseData(triggerHomepageToProjectTransition)

            let tileStartHeight;
            let tileStartWidth;
            let targetWidth;
            let targetHeight;
            let bgScaler;
            let startScaler = [1, 1];
            try{
                if(triggerHomepageToProjectTransition[1]){
                    startScaler = gridTileScales;
                }
                setTileScales(startScaler);
            }catch{}
            if(window.innerWidth > 775){
                if(primaryInput !== "mouse"){
                    targetWidth = (window.innerWidth - (getGutterWidth(window.innerWidth).main *2));
                    targetHeight = Math.min(targetWidth * (9/16), window.innerHeight - 180)
                    tileStartHeight = startScaler[1] * (window.innerHeight/4) - 20;
                    tileStartWidth = (startScaler[0] * 1.25 * 1.33*((window.innerHeight/4) - 20));
                }else {
                    targetWidth = (window.innerWidth - (getGutterWidth(window.innerWidth).main *2));
                    targetHeight = Math.min(targetWidth * (9/16), window.innerHeight - 180)
                    tileStartHeight = startScaler[1] * (window.innerHeight/5 - 20);
                    if(triggerHomepageToProjectTransition[1]) tileStartWidth = (startScaler[0] * 1.9 *(window.innerHeight/5));
                    else tileStartWidth = (startScaler[0] * 1.9*(window.innerHeight/5) + 1);
                }
                bgScaler = [targetWidth/tileStartWidth, targetHeight/tileStartHeight];
                setProjectScaler(bgScaler);
                // let tmpSideDelta = (window.innerWidth/2) - 70 - (((((window.innerHeight/4) - 20) * 1.33 * 1.25) + 1)/2);
                // let tmpVertDelta = ((window.innerHeight/2) - 60) - (0.5 * ((window.innerHeight/4)-20));
            } else  if(window.innerWidth<=775){
                targetWidth = (window.innerWidth - (getGutterWidth(window.innerWidth).main *2));
                targetHeight = targetWidth / (projData[triggerHomepageToProjectTransition[0]].aspectRatio);
    
                if(primaryInput !== 'mouse'){
                    tileStartHeight = startScaler[1] *(window.innerHeight/4) - 20;
                    tileStartWidth = (startScaler[0] * 1.25 * 1.33*((window.innerHeight/4) - 20));
                } else{
                    tileStartHeight = (startScaler[1] *window.innerHeight/5) - 20;
                    tileStartWidth = (startScaler[0] * 2.25 *(window.innerHeight/5));
                }
                let bgScaler = [targetWidth/tileStartWidth, targetHeight/tileStartHeight];
                setExpandLowerHeight(targetHeight);
                setProjectScaler(bgScaler);
            }

            
            setStartTileHeight(tileStartHeight);
            setStartTileWidth(tileStartWidth);
        } else{
            setUseData(null)
        }
    }, [triggerHomepageToProjectTransition])

    return (
        <>
            {isTablet !== null && tileScales && useData !== null &&
            <>
                <motion.div 
                    className="proj_transition__wrapper" 
                    style={{
                        position: "fixed",
                        top: "60px",
                        left: "50%",
                        width: startTileWidth,
                        height: startTileHeight,
                        zIndex: 11,
                        overflow: "hidden",
                        transform: "translate(cacl(-50% - 1px), calc(50vh - 61px - 50%))",
                        transformOrigin: "top",
                        pointerEvents: "none",
                        zIndex: 100
                    }}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    variants={projTransVariants}
                    custom={[isTablet, triggerHomepageToProjectTransition[1]]}
                >
                    <div className="proj_transition__ele"
                        style={{
                            height: "100%"
                        }}
                    >
                        <div className="h_np_transition__wrapper">
                            <div className={`transition_wiper ${useData!== false && 'right_to_left'}`}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            > 
                                <AnimatePresence>
                                    {
                                        useData[0] !== false &&
                                        <>
                                            <motion.img 
                                                initial="initial"
                                                animate="animate"
                                                exit="exit"
                                                src={projData[useData[0]].thumbnails.placeholder}
                                                style={{
                                                    position: 'absolute',
                                                    width: "100%",
                                                    height: "auto",
                                                    transform: isTablet ? `scale(${projData[useData[0]].aspectRatio / (4/3)})` : null,
                                                    filter: "blur(5px)"
                                                    // objectFit: isTablet ? "cover" : "auto"
                                                }}
                                                variants={transCounterVariants}
                                                custom={
                                                    [
                                                        useData[1] ? gridTileScales[1]/gridTileScales[0] : isTablet ? projData[useData[0]].aspectRatio / (4/3) : 1,
                                                        triggerHomepageToProjectTransition[1],
                                                        0
                                                    ]
                                                }
                                            />
                                            <motion.img 
                                                id="testeste"
                                                initial="initial"
                                                animate="animate"
                                                exit="exit"
                                                src={projData[useData[0]].thumbnails.desktop.replace("desktop", dynamicSrcType)}
                                                style={{
                                                    position: 'absolute',
                                                    width: "100%",
                                                    height: "auto",
                                                    transform: isTablet ? `scale(${projData[useData[0]].aspectRatio / (4/3)})` : null
                                                    // objectFit: isTablet ? "cover" : "auto"
                                                }}
                                                variants={transCounterVariants}
                                                custom={
                                                    [
                                                        useData[1] ? gridTileScales[1]/gridTileScales[0] : isTablet ? projData[useData[0]].aspectRatio / (4/3) : 1,
                                                        triggerHomepageToProjectTransition[1],
                                                        1
                                                    
                                                    ]
                                                }
                                            />
                                            
                                        </>
                                    }
                                </AnimatePresence>
                            </div>
                        </div>
                    </div>
                </motion.div>
                <motion.div 
                    className="grid-trans__wrapper"
                    initial="initial"
                    animate={useData !== false ? "projExit" : "animate"}
                    exit={"exit"}
                    style={{
                        zIndex: 100
                    }}
                >
                    <motion.div
                        className="h-upper-horiz horiz-line" 
                        variants={upperHorizVariants}
                        custom={
                                !isTablet ?
                                    [
                                        ((window.innerHeight/2) - (tileScales[1] * (window.innerHeight/5)/2) - 61 + (10 * tileScales[1])),
                                        -1,
                                        0,
                                        triggerHomepageToProjectTransition[1]
                                    ]
                                :
                                    [
                                        ((window.innerHeight/2) - 60) - (tileScales[1] * 0.5 * ((window.innerHeight/4)-20)),
                                        0,
                                        1,
                                        triggerHomepageToProjectTransition[1]
                                    ]
                        }
                    />
                    <motion.div
                        className="h-lower-horiz horiz-line" 
                        variants={upperHorizVariants}
                        style={{
                            top: 60 + expandLowerHeight
                        }}
                        custom={
                            !isTablet ?
                                [-1 * ((60 + expandLowerHeight) - ((window.innerHeight/2) + (tileScales[1] * (((window.innerHeight/5)/2) - 10)))), 0, 0, triggerHomepageToProjectTransition[1]]
                            :
                                [-1 * ((expandLowerHeight + 60) - ((window.innerHeight/2) + (tileScales[1] * 0.5 * ((window.innerHeight/4) - 20)))), 0, 1, triggerHomepageToProjectTransition[1]]
                        }
                    />
                    <motion.div 
                        className="h-left-vert h-vert" 
                        variants={sideVertVariants}
                        style={{
                            left: sideTransGutter + "px"
                        }}
                        custom={
                            !useData[1] ?
                                !isTablet ?
                                    [((window.innerWidth/2) - (tileScales[0] * 0.5 * (window.innerHeight/5) * 1.9) - 61 - 10), -1, 0, triggerHomepageToProjectTransition[1]]
                                :
                                    [((window.innerWidth/2) - getGutterWidth(window.innerWidth).main - (((((window.innerHeight/4) - 20) * 1.33 * 1.25 * tileScales[0]) + 1)/2)), 1, 1, triggerHomepageToProjectTransition[1]]
                            :
                                !isTablet ?
                                    [((window.innerWidth/2) - (tileScales[0] * 0.5 * (window.innerHeight/5) * 2.25) - 60), -1, 0, triggerHomepageToProjectTransition[1]]
                                :
                                    [((window.innerWidth/2) - getGutterWidth(window.innerWidth).main - (((((window.innerHeight/4) - 20) * 1.33 * 1.25 * tileScales[0]) + 1)/2)), 1, 1, triggerHomepageToProjectTransition[1]]
                        }    
                    />
                    <motion.div
                        className="h-right-vert h-vert" 
                        variants={sideVertVariants}
                        style={{
                            right: sideTransGutter + "px"
                        }}
                        custom={
                            !useData[1] ?
                                !isTablet ?
                                    [-1 * ((window.innerWidth/2) - (tileScales[0] * 0.5 * (window.innerHeight/5) * 1.9) - 61 - 10), 1, 0, triggerHomepageToProjectTransition[1]]
                                :
                                    [-1 * ((window.innerWidth/2) - getGutterWidth(window.innerWidth).main - (((((window.innerHeight/4) - 20) * 1.33 * 1.25 * tileScales[0]) + 1)/2)), 1, 1, triggerHomepageToProjectTransition[1]]
                            :
                            !isTablet ?
                                [-1 * ((window.innerWidth/2) - (tileScales[0] * 0.5 * (window.innerHeight/5) * 2.25) - 60), 1, 0, triggerHomepageToProjectTransition[1]]
                            :
                                [-1 * ((window.innerWidth/2) - getGutterWidth(window.innerWidth).main - (((((window.innerHeight/4) - 20) * 1.33 * 1.25 * tileScales[0]) + 1)/2)), 1, 1, triggerHomepageToProjectTransition[1]]
                        } />

                </motion.div> 
            </>}
        </>
    )
}

export default HomepageOverlayTransition